export const description =
  '艾伦·麦克阿瑟基金会（Ellen MacArthur Foundation）从事教育与培训，企业与政府，洞察与分析，系统性计划和沟通工作，以加速向循环经济的过渡。';

export const registrationNumbers = [
  '慈善登记号码: 1130306',
  'OSCR注册号: SC043120',
  '公司编号: 6897785',
  'Ellen MacArthur Foundation ANBI RSIN nummer: 8257 45 925',
];

export const primaryLinks = [
  {
    title: '关于我们',
    url: `/zh/about-us`,
  },
  {
    title: '我们的网络',
    url: `/zh/standard/network/overview`,
  },
  {
    title: '职位空缺',
    url: `/zh/jobs`,
  },
  {
    title: '联系我们',
    url: `/zh/contact-us`,
  },
  {
    title: '地区',
    url: `/zh/standard/regions/overview`,
  },
  {
    title: '新闻室',
    url: `/zh/standard/media-centre/overview`,
  },
];

export const secondaryLinks = [
  // Optional - currently all links fit in one column
];

export const subContentLinks = [
  {
    title: '法律',
    url: '/法律',
  },
  {
    title: '隐私',
    url: '/隐私',
  },
  {
    title: '饼干',
    url: '/饼干',
  },
];

// @todo:  translate
export const partners = {
  text: 'The work of the Ellen MacArthur Foundation is supported by our ',
  linkText: 'Strategic Partners and Partners.',
  linkUrl: '/network/who-is-in-the-network',
};

export const socialLinks = [
  {
    type: 'facebook',
    alt: 'Link to EMF Facebook page. Opens in a new tab.',
    url: 'https://www.facebook.com/EllenMacArthurFoundation',
  },
  {
    type: 'linkedIn',
    alt: 'Link to EMF LinkedIn page. Opens in a new tab.',
    url: 'https://uk.linkedin.com/company/ellen-macarthur-foundation',
  },
  {
    type: 'twitter',
    alt: 'Link to EMF Twitter page. Opens in a new tab.',
    url: 'https://twitter.com/circulareconomy',
  },

  {
    type: 'youTube',
    alt: 'Link to EMF YouTube page. Opens in a new tab.',
    url: 'https://www.youtube.com/user/made2bemadeagain',
  },
  {
    type: 'instagram',
    alt: 'Link to EMF Instagram page. Opens in a new tab.',
    url: 'https://www.instagram.com/ellenmacarthurfoundation/',
  },
  {
    type: 'medium',
    alt: 'Link to EMF Medium page. Opens in a new tab.',
    url: 'https://medium.com/@circulareconomy',
  },
  {
    type: 'tiktok',
    alt: 'Link to EMF TikTok page. Opens in a new tab.',
    url: 'https://tiktok.com/@ellenmacarthurfoundation',
    width: '28',
    height: '28',
  },
  {
    type: 'threads',
    alt: 'Link to EMF threads page. Opens in a new tab.',
    url: 'https://www.threads.net/@ellenmacarthurfoundation',
    width: '28',
    height: '28',
  },
];

export const poweredByContentful = {
  text: 'Powered by Contentful',
  url: 'https://www.contentful.com/',
};
